import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Modal as MuiModal
} from '@mui/material';
import {  Edit } from '@mui/icons-material';
import { PlusOutlined } from '@ant-design/icons';
import { Button as AntButton, Card, Col, Divider, Input, Modal as AntModal, Row, Tabs } from 'antd';
import styled from 'styled-components';
import PasswordRevealInline from 'components/PasswordRevealInline';
import moment from 'moment';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCurrentOrg } from 'store/organizations/selectors';
import { handleEnableDiableUser } from 'store/users/thunks';

import Loading from 'components/Loading';
import Login_as from 'features/forms/admin/Login_as';
import VocabAccessModal from 'components/admin/VocabPermission';
import COLOR from 'utils/constants/color';
import { handleGetStudentForOrg, handleSearchUserForOrg } from 'store/organizations/thunks';
import SpinLoader from 'components/Loader/SpinLoader';
import { getUserIntegrationDetail } from 'utils/methods/textMethod';
import usePermissionForUser from 'components/hooks/permissions/usePermissionForUser';
import { openAutologin } from 'store/keystore/thunks';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';

const BORDERCOLOR = [
  'rgb(200,109,152)',
  'rgb(146,158,227)',
  'rgb(80,233,200)',
  'rgb(238,206,151)'
];

const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const SectionTitle = styled.p`
  color: black;
  font-size: 17px;
  font-weight: 400;
`;

const Highlight = styled.span`
  font-weight: 600;
`;

const ViewDemo = styled.span`
  color: ${({ color }) => color};
  margin-left: 4px;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${COLOR.white};
  border-radius: 3px;
  padding: 16px;
  text-align: center;
`;

const ModalActions = styled(Row)`
  margin-top: 16px;
  justify-content: center;
`;
const BarsLoader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
  height: 10px;
  gap: 3px;

  span {
    width: 4px;
    background: #722ed1;
    animation: barAnim 0.8s infinite;
  }

  span:nth-child(1) { animation-delay: 0s; }
  span:nth-child(2) { animation-delay: 0.1s; }
  span:nth-child(3) { animation-delay: 0.2s; }

  @keyframes barAnim {
    0%, 100% { height: 6px; opacity: 0.3; }
    50% { height: 12px; opacity: 1; }
  }
`;

export default function StudentsTable({
  userloading,
  onTabsJump = () => {},
  active_tab
}) {
  const {isUserCoach, isDistrictAdmin} = usePermissionForUser();
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const org = useCurrentOrg();

  // State
  const [pageInfo, setPageInfo] = useState({ page: 0, rowsPerPage: 100 });
  const [demopageInfo, setdemoPageInfo] = useState({ page: 0, rowsPerPage: 100 });
  const [searchText, setSearchText] = useState('');
  const [activeTab, setActiveTab] = useState('1');
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [confirmUser, setConfirmUser] = useState(null);
  const [enableLoadingId, setEnableLoadingId] = useState(null);
  const [data_loading, setDataLoading] = useState(false);
  const [total_count, setToatalCount] = useState(0);
  const [allStudents,setAllStudents] = useState([]) 
  const [total_count_demo, setToatalCountDemo] = useState(0);
  const [allStudentsDemo,setAllStudentsDemo] = useState([]) 
  const [searchResults, setSearchResults] = useState([]);
  const [demoSearchResults, setDemoSearchResults] = useState([]);
  const [searchLoader,setSearchLoader] = useState(false)
  const [autologinLoader, setAutologinLoader] = useState(false);
  const prevOrgIdRef = useRef(org?.id);

  async function searchStudents() {
    try {
      setSearchLoader(true);
      const response = await dispatch(
        handleSearchUserForOrg(0, 100, org.id, false, searchText)
      );
      if (response?.success) {
        setSearchResults(response.data?.users || []);
        setToatalCount(response.data?.total_count || 0);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setSearchLoader(false);
    }
  }

  async function searchDemoStudents() {
    try {
      setSearchLoader(true);
      const response = await dispatch(
        handleSearchUserForOrg(0,100,org.id,true, searchText) // true = demo
      );
      if (response?.success) {
        setDemoSearchResults(response.data?.users || []);
        setToatalCountDemo(response.data?.total_count || 0);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setSearchLoader(false);
    }
  }
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (active_tab !== "see_students") return;
      if (!org?.id) return;

      if (searchText) {
        if (activeTab === '1') {
          searchStudents();
        } else {
          searchDemoStudents();
        }
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, org, activeTab]);
  
  const onSearchBlank = useCallback((e) => {
    if (activeTab === '1') {
      getStudentInfo();
    } else {
      getDemoStudent();
    }
  }, [activeTab, org]);
  async function getStudentInfo() {
    try {
      setDataLoading(true)
      const response = await dispatch(handleGetStudentForOrg(pageInfo.page*pageInfo.rowsPerPage, pageInfo.rowsPerPage, org.id))
      if (response && response.success) {
        const { total_count, teachers: teachersResult } = response.data || {};
        setToatalCount(total_count)
        setAllStudents(teachersResult)
      }
    } catch (error) {
      console.error('getStudentInfo error:', error);
    } finally {
      setDataLoading(false)
    }

  }
  async function getDemoStudent() {
    try {
      setDataLoading(true)
      const response = await dispatch(handleGetStudentForOrg(demopageInfo.page*demopageInfo.page, demopageInfo.rowsPerPage, org.id,true))
      if (response && response.success) {
        const { total_count, teachers: teachersResult } = response.data || {};
        setToatalCountDemo(total_count)
        setAllStudentsDemo(teachersResult)
      }
    } catch (error) {

    } finally {
      setDataLoading(false)
    }

  }

  useEffect(() => {
    if (org && org.id) {
      if (active_tab != "see_students") return;
      if (activeTab == 1) {
        getStudentInfo()
      }

    }
  }, [org, pageInfo, active_tab, activeTab])
  useEffect(() => {
    if (org && org.id) {
      if (active_tab != "see_students") return;
      if (activeTab == 2) {
        getDemoStudent()
      }
    }
  }, [org, active_tab, activeTab,demopageInfo])

  useEffect(() => {
    if (active_tab !== "see_students") return;
    if (prevOrgIdRef.current !== undefined && prevOrgIdRef.current !== org?.id) {
      setSearchText('');
      setSearchResults([]);
      setDemoSearchResults([]);
    }
    prevOrgIdRef.current = org?.id;
  }, [org?.id, active_tab])

  const baseList = useMemo(() => {
    const list = activeTab == '1' ? allStudents : allStudentsDemo;
    return sortBy(list || [], [
      (u) => (u.firstName).trim().toLowerCase(),
      (u) => (u.lastName).trim().toLowerCase()
    ]);
  }, [allStudents, allStudentsDemo, activeTab]);

  // apply search
  const filtered = useMemo(() => {
    if (!searchText) return baseList;
    const search_list = activeTab === '1' ? searchResults : demoSearchResults;
    return sortBy(search_list || [], [
      (u) => (u.firstName).trim().toLowerCase(),
      (u) => (u.lastName).trim().toLowerCase()
    ]);
  }, [baseList, searchText , searchResults , demoSearchResults, activeTab ]);

  // Handlers
  const onSearch = useCallback((e) => {
    if( e.target.value.trim() === '') {
      onSearchBlank(e);
    }
    setSearchText(e.target.value);
  }, []);

  const onPageChange = useCallback((_, newPage) => {
    setPageInfo((p) => ({ ...p, page: newPage }));
  }, []);

  const onRowsPerPageChange = useCallback((e) => {
    setPageInfo({ page: 0, rowsPerPage: +e.target.value });
  }, []);
  const onDemoPageChange = useCallback((_, newPage) => {
    setdemoPageInfo((p) => ({ ...p, page: newPage }));
  }, []);

  const onRowsPerDemoPageChange = useCallback((e) => {
    setdemoPageInfo({ page: 0, rowsPerPage: +e.target.value });
  }, []);

  const openDetail = useCallback((u) => {
    const created = get(u, 'createdAt', '');
    const dateStr = created
      ? moment(parseInt(created)).format('YYYY-MM-DD HH:mm:ss')
      : '';
    setDetailData({ ...u, date: dateStr });
    setDetailOpen(true);
  }, []);

  const handleOpenAutologin = async (schoologyid) => {
    setAutologinLoader(true);
    try {
      const result = await openAutologin(schoologyid);
      if (result && !result.success) {
        showAlert(result.message || 'Autologin URL not found', 'error');
      }
    } catch (error) {
      showAlert('Error fetching autologin URL. Please try again.', 'error');
    } finally {
      setAutologinLoader(false);
    }
  };

  const closeDetail = useCallback(() => setDetailOpen(false), []);

  const openConfirm = useCallback((u) => setConfirmUser(u), []);
  const closeConfirm = useCallback(() => setConfirmUser(null), []);

  const handleToggleActive = useCallback(async () => {
    if (!confirmUser) return;
    setEnableLoadingId(confirmUser.id);
    const response = await dispatch(
      handleEnableDiableUser(confirmUser.id, !confirmUser.active)
    );
     if(response){
      setAllStudents((prev) => {
        return prev?.map((element) => {
          if (element.id === response.id) {
            return { ...element, active: !confirmUser.active };
          }
          else{
            return element
          }
        })
      })
      setAllStudentsDemo((prev) => {
        return prev?.map((element) => {
          if (element.id === response.id) {
            return { ...element, active: !confirmUser.active };
          }
          else{
            return element
          }
        })
      })
    }

      if(searchText?.length > 0){
        setSearchResults((prev) => {
          return prev?.map((element) => {
            if(element.id === response.id){
              return { ...element, active: !confirmUser.active };
            }
            else{
              return element
            }
          })
        });
        setDemoSearchResults((prev) => {
          return prev?.map((element) => {
            if(element.id === response.id){
              return { ...element, active: !confirmUser.active };
            }
            else{
              return element
            }
          })
        });
      }
    setEnableLoadingId(null);
    closeConfirm();
  }, [dispatch, confirmUser, closeConfirm]);



  const onAddStudent = useCallback(
    (isEdit = false) =>
      navigate('/add-users', {
        state: { userData: isEdit ? detailData : { role:"student" }, isEdit }
      }),
    [navigate, detailData]
  );

 

  // Column definitions
  const columns = [
    {
      label: 'School Name',
      render: (u) => {
        return (
          <>
            {get(u, 'school_name', '')}
          </>
        );
      }
    },
    { label: 'First Name',      render: (u) => u.firstName },
    { label: 'Last Name',       render: (u) => u.lastName },
    { label: 'No. of Classes',  render: (u) => u.primary_classes?.length||0 },
    { label: 'Primary Class',   render: (u) => Array.isArray(u.primary_classes)?u.primary_classes.join(","):'' },
    { label: 'Primary Teacher', render: (u) => Array.isArray(u.primary_teachers)?u.primary_teachers.join(","):'' },
    {
      label: 'Status',
      render: (u) => (
        <Button
          variant="contained"
          color={u.active ? 'primary' : 'secondary'}
          sx={{ fontSize: 12, width: 80 }}
          disabled={isUserCoach}
          onClick={(e) => { e.stopPropagation(); openConfirm(u); }}
        >
          {enableLoadingId === u.id
            ? <Loading size={18} white />
            : u.active ? 'Enabled' : 'Disabled'}
        </Button>
      )
    }
  ];
  // Build Tabs
  const tabs = [
    {
      key: '1',
      label: 'Students',
      children: (
        <TableContainer sx={{ backgroundColor: '#fff' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((c, i) => (
                  <TableCell
                    key={i}
                    sx={{ fontSize: 16, fontWeight: 600, textAlign: 'left' }}
                  >
                    {c.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {isEmpty(filtered) ? (
                userloading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <Loading size={30} />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No results
                    </TableCell>
                  </TableRow>
                )
              ) : (
                filtered.map((u) => (
                  <TableRow
                    key={u.id}
                    hover
                    sx={{ cursor: 'pointer' }}
                    onClick={() => { openDetail(u); }}
                  >
                    {columns.map((c, j) => (
                      <TableCell key={j} sx={{ textAlign: 'left' }}>
                        {c.render(u)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={total_count}
                  page={pageInfo.page}
                  rowsPerPage={pageInfo.rowsPerPage}
                  onPageChange={onPageChange}
                  onRowsPerPageChange={onRowsPerPageChange}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  slotProps={{
                    actions: {
                      backIconButtonProps: { color: 'secondary' },
                      nextIconButtonProps: { color: 'secondary' }
                    }
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )
    },
    {
      key: '2',
      label: 'Demo Students',
      children: (
        <TableContainer sx={{ backgroundColor: '#fff' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((c, i) => (
                  <TableCell
                    key={i}
                    sx={{ fontSize: 16, fontWeight: 600, textAlign: 'left' }}
                  >
                    {c.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {isEmpty(filtered) ? (
                userloading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <Loading size={30} />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No results
                    </TableCell>
                  </TableRow>
                )
              ) : (
                filtered
                  .map((u) => (
                    <TableRow
                      key={u.id}
                      hover
                      sx={{ cursor: 'pointer' }}
                      onClick={() => { openDetail(u); }}
                    >
                      {columns.map((c, j) => (
                        <TableCell key={j} sx={{ textAlign: 'left' }}>
                          {c.render(u)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={total_count_demo}
                  page={demopageInfo.page}
                  rowsPerPage={demopageInfo.rowsPerPage}
                  onPageChange={onDemoPageChange}
                  onRowsPerPageChange={onRowsPerDemoPageChange}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  slotProps={{
                    actions: {
                      backIconButtonProps: { color: 'secondary' },
                      nextIconButtonProps: { color: 'secondary' }
                    }
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )
    }
  ];

  return (
    <>
    <SpinLoader dataloader={data_loading} />
      {/* Enable/Disable confirm */}
      <MuiModal open={!!confirmUser} onClose={closeConfirm}>
        <ModalContent>
          Are you sure you want to {confirmUser?.active ? 'disable' : 'enable'}{' '}
          {get(confirmUser, 'firstName', '')}{' '}
          {get(confirmUser, 'lastName', '')}?
          <ModalActions>
            <Button onClick={closeConfirm} sx={{ mr: 1 }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleToggleActive}
              disabled={enableLoadingId === confirmUser?.id}
            >
              Yes
            </Button>
          </ModalActions>
        </ModalContent>
      </MuiModal>

      {/* Detail modal */}
      <AntModal
        title={`${get(detailData, 'firstName', '')} ${get(detailData, 'lastName', '')}`}
        open={detailOpen}
        destroyOnHidden
        onCancel={closeDetail}
        footer={null}
        centered
        width="60%"
      >
        <Row justify="space-between" align="middle">
          {isUserCoach ? null : (
            <AntButton  icon={<Edit />} onClick={() => onAddStudent(true)}>
              Edit Profile
            </AntButton>
          )}
         
          <Row gap={10}>
            <Login_as user={detailData} />
            {get(detailData, 'schoologyid', '') && (
              <AntButton
                disabled={!detailData?.active || autologinLoader}
                onClick={() => handleOpenAutologin(get(detailData, 'schoologyid', ''))}
                loading={autologinLoader}
              >
                Log in with Auto-Login
              </AntButton>
            )}
            <VocabAccessModal id={detailData?.id} type="student" />
          </Row>
        </Row>

        <Card type="inner" title="Detail View" style={{ marginTop: 16 }}>
          <Row gutter={16}>
            <Col span={12}>
              <p><strong>First name:</strong> {get(detailData, 'firstName', '')}</p>
              <p><strong>Username:</strong>  {get(detailData, 'username', '')}</p>
              <p><strong>Status:</strong>    {detailData?.active ? 'Enabled' : 'Disabled'}</p>
              {getUserIntegrationDetail(detailData)}
            </Col>
            <Col span={12}>
              <p><strong>Last name:</strong> {get(detailData, 'lastName', '')}</p>
              <p><strong>Password:</strong>   <PasswordRevealInline userId={detailData?.id} username={detailData?.username} /></p>
              <p><strong>Class Name:</strong>{Array.isArray(detailData?.primary_classes)?detailData.primary_classes.join(","):''}</p>
              <p><strong>Primary Teacher:</strong> {Array.isArray(detailData?.primary_teachers)?detailData.primary_teachers.join(","):'' }</p>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col span={12}>
              <p>
                <strong>School Name:</strong>{' '}
                <span
                  style={{ color: '#1464FF', cursor: 'pointer' }}
                  onClick={() => onTabsJump('see_schools', detailData)}
                >
                  {get(detailData, 'school_name', '')}
                </span>
              </p>
            </Col>
          </Row>
        </Card>
      </AntModal>

      {/* Toolbar & Tabs */}
      <Wrapper>
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          {isUserCoach ? null : (
            <AntButton
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => onAddStudent(false)}
            >
              Add Students
            </AntButton>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Input
              placeholder="Search Students by name"
              value={searchText}
              onChange={onSearch}
              style={{ width: 250 }}
            />
            {searchLoader && (
            <BarsLoader>
              <span></span>
              <span></span>
              <span></span>
            </BarsLoader>
          )}
          </div>
        </Row>
        

        <SectionTitle>
          View <Highlight>Student</Highlight> Records.
        </SectionTitle>

        <Tabs
          activeKey={activeTab}
          onChange={(key) => {
            if(key=='1'){
              setPageInfo({page:0,rowsPerPage:100})
            }else{
              setdemoPageInfo({page:0, rowsPerPage:100})
            }
            setActiveTab(key);
          }}
          items={tabs}
        />
      </Wrapper>
    </>
  );
}